import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { boldBlueHeader } from './styles'
import { SelectedBid } from '../../shared/types'
import {
  formatDateTime,
  formatCurrency,
  roundToDecimals,
} from '../../shared/formats.ts'

interface Props {
  selectedBid: SelectedBid
}

export default function ReadOnlySelectedBid({ selectedBid }: Props) {
  return (
    <Box
      sx={{
        border: '2px solid',
        borderColor: 'success.main',
        borderRadius: 1,
        px: 2,
        py: 1.5,
        mt: 1,
        mb: 1,
        boxShadow: '0 2px 8px rgba(76, 175, 80, 0.2)',
        backgroundColor: 'success.light' + '20',
        position: 'relative',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <CheckCircleIcon
          sx={{
            color: 'success.dark',
            mr: 1,
            fontSize: '1.2rem',
          }}
        />
        <Typography
          variant="h6"
          sx={{
            color: 'success.dark',
            fontWeight: 600,
          }}
        >
          Selected Bid
        </Typography>
      </Box>

      <Table
        size="small"
        sx={{
          mb: 1,
          border: '1px solid',
          borderColor: 'success.light',
          backgroundColor: 'white',
        }}
      >
        <TableBody
          sx={{
            '& td, & th': {
              border: '1px solid',
              borderColor: 'success.light',
            },
          }}
        >
          <TableRow>
            <TableCell sx={{ ...boldBlueHeader, color: 'success.dark' }}>
              Rate
            </TableCell>
            <TableCell>
              {selectedBid.rate != null
                ? `${roundToDecimals(selectedBid.rate, 3)}%`
                : '-'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ ...boldBlueHeader, color: 'success.dark' }}>
              Treasury Rate
            </TableCell>
            <TableCell>
              {selectedBid.treasuryRate != null
                ? `${roundToDecimals(selectedBid.treasuryRate, 3)}%`
                : '-'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ ...boldBlueHeader, color: 'success.dark' }}>
              Amount
            </TableCell>
            <TableCell>{formatCurrency(selectedBid.amount)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Typography
        variant="subtitle2"
        sx={{
          color: 'success.dark',
          mb: 0.5,
          fontWeight: 500,
        }}
      >
        Selected {formatDateTime(selectedBid.createdAt)}
      </Typography>
    </Box>
  )
}
